import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';

import { PageContainer, PageHeaderTitle, PageHeaderDetails } from '../common/Page';
import ProposalCard from '../select_renewal/ProposalCard';

import { selectProposal, selectLeaseTerm } from '../../store/actions';

const SelectRenewal = ({
  proposals,
  selectProposal,
  pageIndex,
  setPageIndex,
  lastPageIndex,
  selectLeaseTerm,
}) => {
  const moveForward = useCallback(
    () => {
      if (pageIndex !== lastPageIndex) {
        return setPageIndex(pageIndex + 1);
      }
    },
    [pageIndex, lastPageIndex, setPageIndex]
  );

  useEffect(
    () => {
      selectLeaseTerm(undefined);
    },
    [selectLeaseTerm]
  );

  const handleSelection = index => {
    selectProposal(proposals[index]);
    moveForward();
  };

  return (
    <PageContainer>
      <PageHeaderTitle>
        {getTranslatedString('landlordPortal.rentRoll.renewals.selectProposalTitle')}
      </PageHeaderTitle>
      <PageHeaderDetails>
        {getTranslatedString('landlordPortal.rentRoll.renewals.selectProposalDesc')}
      </PageHeaderDetails>
      <div>
        {proposals.map((proposal, i) => (
          <ProposalCard proposal={proposal} index={i} handleSelection={handleSelection} />
        ))}
      </div>
    </PageContainer>
  );
};

const mapStateToProps = store => ({
  proposals: store.landlord.renewals.proposals,
});

const mapDispatchToProps = {
  selectProposal,
  selectLeaseTerm,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectRenewal);
